const languages = [
  {
    name: 'Abjasio',
    id: 'ab',
  },
  {
    name: 'Afar',
    id: 'aa',
  },
  {
    name: 'Afrikáans',
    id: 'af',
  },
  {
    name: 'Aimara',
    id: 'ay',
  },
  {
    name: 'Akan',
    id: 'ak',
  },
  {
    name: 'Albanés',
    id: 'sq',
  },
  {
    name: 'Alemán',
    id: 'de',
  },
  {
    name: 'Amárico',
    id: 'am',
  },
  {
    name: 'Árabe',
    id: 'ar',
  },
  {
    name: 'Aragonés',
    id: 'an',
  },
  {
    name: 'Armenio',
    id: 'hy',
  },
  {
    name: 'Asamés',
    id: 'as',
  },
  {
    name: 'Avar',
    id: 'av',
  },
  {
    name: 'Avéstico',
    id: 'ae',
  },
  {
    name: 'Azerbaiyano',
    id: 'az',
  },
  {
    name: 'Bambara',
    id: 'bm',
  },
  {
    name: 'Baskir',
    id: 'ba',
  },
  {
    name: 'Bengalí',
    id: 'bn',
  },
  {
    name: 'Bielorruso',
    id: 'be',
  },
  {
    name: 'Birmano',
    id: 'my',
  },
  {
    name: 'Bislama',
    id: 'bi',
  },
  {
    name: 'Bosnio',
    id: 'bs',
  },
  {
    name: 'Bretón',
    id: 'br',
  },
  {
    name: 'Búlgaro',
    id: 'bg',
  },
  {
    name: 'Cachemiro',
    id: 'ks',
  },
  {
    name: 'Canarés',
    id: 'kn',
  },
  {
    name: 'Catalán',
    id: 'ca',
  },
  {
    name: 'Chamorro',
    id: 'ch',
  },
  {
    name: 'Checheno',
    id: 'ce',
  },
  {
    name: 'Checo',
    id: 'cs',
  },
  {
    name: 'Chichewa',
    id: 'ny',
  },
  {
    name: 'Chino',
    id: 'zh',
  },
  {
    name: 'Chuvasio',
    id: 'cv',
  },
  {
    name: 'Cingalés',
    id: 'si',
  },
  {
    name: 'Coreano',
    id: 'ko',
  },
  {
    name: 'Córnico',
    id: 'kw',
  },
  {
    name: 'Corso',
    id: 'co',
  },
  {
    name: 'Cree',
    id: 'cr',
  },
  {
    name: 'Criollo haitiano',
    id: 'ht',
  },
  {
    name: 'Croata',
    id: 'hr',
  },
  {
    name: 'Danés',
    id: 'da',
  },
  {
    name: 'Divehi',
    id: 'dv',
  },
  {
    name: 'Dzongkha',
    id: 'dz',
  },
  {
    name: 'Eslavo eclesiástico',
    id: 'cu',
  },
  {
    name: 'Eslovaco',
    id: 'sk',
  },
  {
    name: 'Esloveno',
    id: 'sl',
  },
  {
    name: 'Español',
    id: 'es',
  },
  {
    name: 'Esperanto',
    id: 'eo',
  },
  {
    name: 'Estonio',
    id: 'et',
  },
  {
    name: 'Ewé',
    id: 'ee',
  },
  {
    name: 'Feroés',
    id: 'fo',
  },
  {
    name: 'Finés',
    id: 'fi',
  },
  {
    name: 'Fiyiano',
    id: 'fj',
  },
  {
    name: 'Francés',
    id: 'fr',
  },
  {
    name: 'Frisón occidental',
    id: 'fy',
  },
  {
    name: 'Fula',
    id: 'ff',
  },
  {
    name: 'Gaélico escocés',
    id: 'gd',
  },
  {
    name: 'Galés',
    id: 'cy',
  },
  {
    name: 'Gallego',
    id: 'gl',
  },
  {
    name: 'Ganda',
    id: 'lg',
  },
  {
    name: 'Georgiano',
    id: 'ka',
  },
  {
    name: 'Griego',
    id: 'el',
  },
  {
    name: 'Groenlandés',
    id: 'kl',
  },
  {
    name: 'Guaraní',
    id: 'gn',
  },
  {
    name: 'Guyaratí',
    id: 'gu',
  },
  {
    name: 'Hausa',
    id: 'ha',
  },
  {
    name: 'Hebreo',
    id: 'he',
  },
  {
    name: 'Herero',
    id: 'hz',
  },
  {
    name: 'Hindi',
    id: 'hi',
  },
  {
    name: 'Hiri motu',
    id: 'ho',
  },
  {
    name: 'Húngaro',
    id: 'hu',
  },
  {
    name: 'Ido',
    id: 'io',
  },
  {
    name: 'Igbo',
    id: 'ig',
  },
  {
    name: 'Indonesio',
    id: 'id',
  },
  {
    name: 'Inglés',
    id: 'en',
  },
  {
    name: 'Interlingua',
    id: 'ia',
  },
  {
    name: 'Interlingue',
    id: 'ie',
  },
  {
    name: 'Inuktitut',
    id: 'iu',
  },
  {
    name: 'Inupiaq',
    id: 'ik',
  },
  {
    name: 'Irlandés',
    id: 'ga',
  },
  {
    name: 'Islandés',
    id: 'is',
  },
  {
    name: 'Italiano',
    id: 'it',
  },
  {
    name: 'Japonés',
    id: 'ja',
  },
  {
    name: 'Javanés',
    id: 'jv',
  },
  {
    name: 'Jemer',
    id: 'km',
  },
  {
    name: 'Kanuri',
    id: 'kr',
  },
  {
    name: 'Kazajo',
    id: 'kk',
  },
  {
    name: 'Kikuyu',
    id: 'ki',
  },
  {
    name: 'Kinyarwanda',
    id: 'rw',
  },
  {
    name: 'Kirguís',
    id: 'ky',
  },
  {
    name: 'Kirundi',
    id: 'rn',
  },
  {
    name: 'Komi',
    id: 'kv',
  },
  {
    name: 'Kongo',
    id: 'kg',
  },
  {
    name: 'Kuanyama',
    id: 'kj',
  },
  {
    name: 'Kurdo',
    id: 'ku',
  },
  {
    name: 'Lao',
    id: 'lo',
  },
  {
    name: 'Latín',
    id: 'la',
  },
  {
    name: 'Letón',
    id: 'lv',
  },
  {
    name: 'Limburgués',
    id: 'li',
  },
  {
    name: 'Lingala',
    id: 'ln',
  },
  {
    name: 'Lituano',
    id: 'lt',
  },
  {
    name: 'Luba-katanga',
    id: 'lu',
  },
  {
    name: 'Luxemburgués',
    id: 'lb',
  },
  {
    name: 'Macedonio',
    id: 'mk',
  },
  {
    name: 'Malayalam',
    id: 'ml',
  },
  {
    name: 'Malayo',
    id: 'ms',
  },
  {
    name: 'Malgache',
    id: 'mg',
  },
  {
    name: 'Maltés',
    id: 'mt',
  },
  {
    name: 'Manés',
    id: 'gv',
  },
  {
    name: 'Maorí',
    id: 'mi',
  },
  {
    name: 'Maratí',
    id: 'mr',
  },
  {
    name: 'Marshalés',
    id: 'mh',
  },
  {
    name: 'Mongol',
    id: 'mn',
  },
  {
    name: 'Nauruano',
    id: 'na',
  },
  {
    name: 'Navajo',
    id: 'nv',
  },
  {
    name: 'Ndebele del norte',
    id: 'nd',
  },
  {
    name: 'Ndebele meridional',
    id: 'nr',
  },
  {
    name: 'Ndonga',
    id: 'ng',
  },
  {
    name: 'Neerlandés',
    id: 'nl',
  },
  {
    name: 'Nepalí',
    id: 'ne',
  },
  {
    name: 'Noruego',
    id: 'no',
  },
  {
    name: 'Noruego bokmål',
    id: 'nb',
  },
  {
    name: 'Noruego nynorsk',
    id: 'nn',
  },
  {
    name: 'Occitano',
    id: 'oc',
  },
  {
    name: 'Ojibwa',
    id: 'oj',
  },
  {
    name: 'Oriya',
    id: 'or',
  },
  {
    name: 'Oromo',
    id: 'om',
  },
  {
    name: 'Osético',
    id: 'os',
  },
  {
    name: 'Pali',
    id: 'pi',
  },
  {
    name: 'Panyabí',
    id: 'pa',
  },
  {
    name: 'Pastún',
    id: 'ps',
  },
  {
    name: 'Persa',
    id: 'fa',
  },
  {
    name: 'Polaco',
    id: 'pl',
  },
  {
    name: 'Portugués',
    id: 'pt',
  },
  {
    name: 'Portugués (Brasil)',
    id: 'pt_BR',
  },
  {
    name: 'Quechua',
    id: 'qu',
  },
  {
    name: 'Romanche',
    id: 'rm',
  },
  {
    name: 'Rumano',
    id: 'ro',
  },
  {
    name: 'Ruso',
    id: 'ru',
  },
  {
    name: 'Sami septentrional',
    id: 'se',
  },
  {
    name: 'Samoano',
    id: 'sm',
  },
  {
    name: 'Sango',
    id: 'sg',
  },
  {
    name: 'Sánscrito',
    id: 'sa',
  },
  {
    name: 'Sardo',
    id: 'sc',
  },
  {
    name: 'Serbio',
    id: 'sr',
  },
  {
    name: 'Setsuana',
    id: 'tn',
  },
  {
    name: 'Shona',
    id: 'sn',
  },
  {
    name: 'Sindi',
    id: 'sd',
  },
  {
    name: 'Somalí',
    id: 'so',
  },
  {
    name: 'Sotho meridional',
    id: 'st',
  },
  {
    name: 'Suajili',
    id: 'sw',
  },
  {
    name: 'Suazi',
    id: 'ss',
  },
  {
    name: 'Sueco',
    id: 'sv',
  },
  {
    name: 'Sundanés',
    id: 'su',
  },
  {
    name: 'Tagalo',
    id: 'tl',
  },
  {
    name: 'Tahitiano',
    id: 'ty',
  },
  {
    name: 'Tailandés',
    id: 'th',
  },
  {
    name: 'Tamil',
    id: 'ta',
  },
  {
    name: 'Tártaro',
    id: 'tt',
  },
  {
    name: 'Tayiko',
    id: 'tg',
  },
  {
    name: 'Telugu',
    id: 'te',
  },
  {
    name: 'Tibetano',
    id: 'bo',
  },
  {
    name: 'Tigriña',
    id: 'ti',
  },
  {
    name: 'Tongano',
    id: 'to',
  },
  {
    name: 'Tsonga',
    id: 'ts',
  },
  {
    name: 'Turco',
    id: 'tr',
  },
  {
    name: 'Turcomano',
    id: 'tk',
  },
  {
    name: 'Twi',
    id: 'tw',
  },
  {
    name: 'Ucraniano',
    id: 'uk',
  },
  {
    name: 'Uigur',
    id: 'ug',
  },
  {
    name: 'Urdu',
    id: 'ur',
  },
  {
    name: 'Uzbeko',
    id: 'uz',
  },
  {
    name: 'Valón',
    id: 'wa',
  },
  {
    name: 'Vasco',
    id: 'eu',
  },
  {
    name: 'Venda',
    id: 've',
  },
  {
    name: 'Vietnamita',
    id: 'vi',
  },
  {
    name: 'Volapük',
    id: 'vo',
  },
  {
    name: 'Wólof',
    id: 'wo',
  },
  {
    name: 'Xhosa',
    id: 'xh',
  },
  {
    name: 'Yi de Sichuán',
    id: 'ii',
  },
  {
    name: 'Yidis',
    id: 'yi',
  },
  {
    name: 'Yoruba',
    id: 'yo',
  },
  {
    name: 'Zhuang',
    id: 'za',
  },
  {
    name: 'Zulú',
    id: 'zu',
  },
];

export const getLanguageName = (languageCode = '') => {
  const languageObj =
    languages.find(language => language.id === languageCode) || {};
  return languageObj.name || '';
};

export const getLanguageDirection = (languageCode = '') => {
  const rtlLanguageIds = ['ar', 'as', 'fa', 'he', 'ku', 'ur'];
  return rtlLanguageIds.includes(languageCode);
};

export default languages;
